<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
    <a [routerLink]="['/pedido']">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>

    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Compra en comercio</h1>
    </div>

    <div class="p-2 pl-2 help" (click)="openhelp()">
      <i class="bi bi-info-circle"></i>
    </div>
  </div>

  <!-- Tooltip ayuda -->
  <div class="row m-3 p-3 align-items-center" id="tooltip-pwa" [class.is-open]="helpOpen">
    <div class="col-auto"><i class="bi bi-info-circle" style="font-size: 1.8em;"></i></div>
    <div class="col" id="helpinfo">{{ helpText }}</div>
    <div class="col-auto" (click)="openhelp()"><i class="bi bi-x-lg" style="font-size: 1.4em;"></i></div>
  </div>

  <form (ngSubmit)="saveCondiciones()" [formGroup]="condiciones">
    <div class="row mb-3 mt-3 p-3 text-start">
      <span><b>Forma de entrega</b></span>

      <div class="mt-1">
        <div class="row p-3 pb-0 align-items-center">
          <div class="col align-items-center form-switch ps-0 d-flex align-items-center justify-content-between">
            <div class="col-8 col-lg-10 col-sm-8">
              <label class="form-check-label col text-title-item">Retiro en local</label>
            </div>
            <div class="col-auto">
              <input
                class="form-check-input ms-3"
                type="checkbox"
                id="b_retiro_local"
                formControlName="b_retiro_local"
                (change)="control('b_retiro_local')"
              />
            </div>
          </div>
        </div>

        <div class="row p-3 pb-0 align-items-center" (click)="onIntentarEnvioDomicilio()">
          <div class="col align-items-center form-switch ps-0 d-flex align-items-center justify-content-between">
            <div class="col-8 col-lg-10 col-sm-8">
              <label class="form-check-label col text-title-item" [class.opacity-50]="!mercadoPagoDisponible">A domicilio</label>
            </div>
            <div class="col-auto">
              <input
                class="form-check-input ms-3"
                type="checkbox"
                id="b_envio_domicilio"
                formControlName="b_envio_domicilio"
                (change)="control('b_envio_domicilio')"
                [disabled]="!mercadoPagoDisponible"
                [class.opacity-50]="!mercadoPagoDisponible"
              />
            </div>
          </div>
          @if (!mercadoPagoDisponible && showEnvioMpWarning) {
            <div class="col-12 p-3" id="tooltip-pwa-alert">
              <label class="form-check-label col text-title-item text-description">
                Este comercio no tiene Mercado Pago habilitado, por eso solo está disponible retiro en el local.
              </label>
            </div>
          }
        </div>

        @if (condiciones.get('b_envio_domicilio')?.value) {
          <div class="row p-3 pb-0 align-items-center">
            <div class="col align-items-center form-switch ps-0 d-flex align-items-center justify-content-between">
              <div class="col rounded">
                <span class="text-description">{{ zona }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <hr class="divisor mt-4 mb-4" />

    <div class="row mb-3 mt-3 p-3 text-start">
      <span><b>Forma de pago</b></span>

      <div class="mt-1">
        <div class="row p-3 pb-0 align-items-center">
          <div class="col align-items-center form-switch ps-0 d-flex align-items-center justify-content-between">
            <div class="col-8 col-lg-10 col-sm-8">
              <label class="form-check-label col text-title-item">Efectivo (retiro en local)</label>
            </div>
            <div class="col-auto">
              <input
                class="form-check-input ms-3"
                type="checkbox"
                id="b_pago_efectivo"
                formControlName="b_pago_efectivo"
                (change)="control('b_pago_efectivo')"
              />
            </div>
          </div>
        </div>

        <div class="row p-3 pb-0 align-items-center" (click)="onIntentarEnvioDomicilio()">
          <div class="col align-items-center form-switch ps-0 d-flex align-items-center justify-content-between">
            <div class="col-8 col-lg-10 col-sm-8">
              <label class="form-check-label col text-title-item" [class.opacity-50]="!mercadoPagoDisponible">Mercadopago</label>
            </div>
            <div class="col-auto">
              <input
                class="form-check-input ms-3"
                type="checkbox"
                id="b_pago_mercadopago"
                formControlName="b_pago_mercadopago"
                (change)="control('b_pago_mercadopago')"
                [disabled]="!mercadoPagoDisponible"
                [class.opacity-50]="!mercadoPagoDisponible"
              />
            </div>
          </div>
          @if (!mercadoPagoDisponible && showEnvioMpWarning) {
            <div class="col-12 p-3" id="tooltip-pwa-alert">
              <label class="form-check-label col text-title-item text-description">
                Este comercio no tiene Mercado Pago habilitado
              </label>
            </div>
          }
        </div>
      </div>
    </div>

    <hr class="divisor mt-4 mb-4" />

    <div class="row mb-5 mt-3 p-3 text-start">
      <div class="col-6 align-middle">
        <div class="col"><b>Receta</b></div>
        <div class="col">
          <label class="form-check-label col text-title-item text-description"><b>En caso de tener una</b></label>
        </div>
      </div>

      <div class="col-6 text-end">
        @if (preview_img_receta) {
          <div class="edit-pencil fileupload rounded-pill pencil" (click)="capturarFileImgReceta()">
            <i class="bi bi-pencil"></i>
          </div>
        }

        <div class="row file btn btn-lg btn-primary fileupload rounded-pill m-0 btn-charge-credential">
          @if (!preview_img_receta) {
            <div class="btn file fileupload m-0 mt-0">
              <div style="background-color: transparent;" (click)="capturarFileImgReceta()">
                <label>Cargar</label>
              </div>
            </div>
          } @else {
            <div>
              <img
                width="100px"
                [src]="preview_img_receta"
                alt="Receta"
                class="receta"
                data-bs-toggle="modal"
                data-bs-target="#modalPreviewImgReceta"
              />
            </div>
          }

          <!-- input file queda por compatibilidad, pero tu captura usa Camera -->
          <input
            type="file"
            class="form-control"
            id="img_receta"
            accept="image/*"
            style="display: none;"
            (change)="onFileSelected($event)"
          />
        </div>
      </div>
    </div>

    <!-- Modal Previw IMG RECETA :: INICIO -->
    <div
      class="modal fade"
      id="modalPreviewImgReceta"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalPreviewImgRecetaLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalPreviewImgRecetaLabel">Receta</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <img [src]="preview_img_receta" class="img-fluid" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Previw IMG RECETA :: FIN -->

    <div class="alert alert-danger mt-2" role="alert" [class.d-none]="error.length == 0">
      <small>{{ error }}</small>
    </div>

    <div class="row fade-in pt-0 mb-3 pb-3 m-2">
      <div class="d-grid mt-0 mb-0">
        <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading">
          {{ loading ? 'Cargando...' : 'Continuar' }}
        </button>
      </div>
    </div>
  </form>
</div>
